import styled from "styled-components";

import { config } from "@sso/config";
import { Flex } from "@sso/ui/FlexBox";

export const DialogOverlay = styled(Flex)`
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: ${p => p.theme.zIndex.modal};
  transition: opacity ${config.dialogFadeInOut}ms ease-in-out;
  ${p => p.opacity && `opacity: ${p.opacity};`}
`;

export const DialogContainer = styled.div<{ maxWidth?: string }>`
  margin: 1rem;
  max-width: ${p => p.maxWidth || "600px"};
  min-width: 500px;
  max-height: calc(80% - 1rem);
  background-color: ${p => p.theme.colors.common.white};
  box-shadow: ${p => p.theme.shadows[5]};
  border-radius: 0.5rem;
  overflow: auto;
  @media (max-width: ${p => p.maxWidth || "600px"}) {
    min-width: 95%;
    max-height: calc(100% - 1rem);
  }
`;
